import { NgModule } from "@angular/core";
import { ILocalStorageServiceConfig, LocalStorageModule } from "angular-2-local-storage";
import { CookieService } from "ngx-cookie-service";
import { SessionStorageService } from "ngx-store";
import { Config } from "src/app/core/config";

const localStorageServiceConfig: ILocalStorageServiceConfig = {
  prefix: Config.lsPrefix,
  storageType: 'localStorage'
};

@NgModule({
  imports: [LocalStorageModule.forRoot(localStorageServiceConfig)],
  providers: [
    CookieService,
    SessionStorageService
  ]
})
export class MiddlewareModule {}
